<div class="filter-area">
  <!-- Zoom In -->
  <div
    class="filter-button"
    (click)="onScale('up')"
    title="{{ 'zoomIn' | translate }}"
  >
    <i class="fa fa-search-plus" aria-hidden="true"></i>
  </div>
  <!-- Zoom Out -->
  <div
    class="filter-button"
    (click)="onScale('down')"
    title="{{ 'zoomOut' | translate }}"
  >
    <i class="fa fa-search-minus" aria-hidden="true"></i>
  </div>
  <!-- Dragging -->
  <div
    (click)="setEditorAction('dragging')"
    class="filter-button"
    [ngClass]="actionType === 'dragging' ? 'active' : ''"
    title="{{ 'drag' | translate }}"
  >
    <i class="fa-regular fa-hand"></i>
  </div>
  <!-- Drawing -->
  <div
    (click)="setEditorAction('drawing')"
    class="filter-button"
    [ngClass]="{
      active: actionType === 'drawing',
      disabled: isEditorActionDisabled()
    }"
    title="{{ 'draw' | translate }}"
  >
    <i class="fa-solid fa-pencil"></i>
  </div>
  <!-- Resize -->
  <div
    (click)="setEditorAction('resizing')"
    class="filter-button"
    [ngClass]="{
      active: actionType === 'resizing',
      disabled: isEditorActionDisabled()
    }"
    title="{{ 'resize' | translate }}"
  >
    <i class="fa-solid fa-up-down-left-right"></i>
  </div>
  <!-- Move -->
  <div
    (click)="setEditorAction('moveRect')"
    class="filter-button"
    [ngClass]="{
      active: actionType === 'moveRect',
      disabled: isEditorActionDisabled()
    }"
    title="{{ 'moveRectangle' | translate }}"
  >
    <i class="fa-solid fa-location-crosshairs"></i>
  </div>
</div>

<div class="canvas-container">
  <canvas
    #canvas
    (mousedown)="onMouseDown($event)"
    (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp()"
  ></canvas>
</div>

<div class="filter-bottom-area">
  <div class="coordinates-area filter-button" *ngIf="imgCoordinates?.x">
    X: {{ imgCoordinates.x || 0 }} Y: {{ imgCoordinates.y || 0 }}
  </div>
</div>
